<template>
  <div class="container fluid">
    <div class="mb-2">
      <date-filter
        @changeDate="onChangeDate"
        :defaultFilter="'last_7_days'"
        v-model="selectedDate"
      ></date-filter>
    </div>

    <!-- Timing of Purchase -->
    <!-- <div class="mt-3 mb-5">
      <TimingOfPurchase></TimingOfPurchase>
    </div> -->

    <!-- Best Seller -->
    <div class="my-5">
      <BestSeller :selectedDate="selectedDate"></BestSeller>
    </div>
    <!-- Best Colors -->
    <div class="my-5">
      <BestColors :selectedDate="selectedDate"></BestColors>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import TimingOfPurchase from './TimingOfPurchase.vue'
import BestSeller from './BestSeller.vue'
import BestColors from './BestColors.vue'

export default {
  components: {
    exportxlsx,
    DateFilter,
    DatePickerWithoutButton,
    apexchart: VueApexCharts,
    TimingOfPurchase,
    BestSeller,
    BestColors
  },
  data() {
    return {
      channelFilter: 'all',
      filter: {
        app: ''
      },
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    moment() {
      return moment
    }
  },
  methods: {
    onChangeDate() {}
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/PurchaseBehavior/SaleReport.vue